import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { Box, Button, LinearProgress } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { coursePackageApi } from '../../../../../../features/course/coursePackage'
import { CoursePackageState } from '../../../../../../features/types'
import BundleTable from '../components/BundleTable'
import BundleDialog from '../components/BundleDialog'

interface Props {
    coursePriceId: number
}

const styles = {
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
}

const BundleTab: React.FC<Props> = ({ coursePriceId }) => {
    const { formatMessage } = useIntl()
    const [openBundleDialog, setOpenBundleDialog] = useState(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [currentRowData, setCurrentRowData] =
        useState<CoursePackageState>(null)

    const { data: packageResponse = null, isFetching } =
        coursePackageApi.useGetCoursePackagesByCoursePriceQuery(
            {
                coursePriceId,
                page: +page,
                size: +rowsPerPage,
            },
            {
                skip: !coursePriceId,
            },
        )
    const [deletePackage, { isLoading: isDeleting }] =
        coursePackageApi.useDeleteCoursePackageMutation()

    const isLoading = isFetching || isDeleting

    const handleRowUpdate = (coursePackage: CoursePackageState) => {
        setCurrentRowData(coursePackage)
        setOpenBundleDialog(true)
    }

    const handleDelete = async (id: number) => {
        try {
            await deletePackage(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {}
    }

    useEffect(() => {
        if (!openBundleDialog) {
            setCurrentRowData(null)
        }
    }, [openBundleDialog])

    return (
        <Box sx={styles.flexColumn}>
            <Box
                ml="auto"
                mb={2}
            >
                <Button
                    onClick={() => setOpenBundleDialog(true)}
                    variant="contained"
                    endIcon={<AddIcon />}
                >
                    {formatMessage({ id: 'addNewPackage' })}
                </Button>
            </Box>

            {isLoading ? (
                <LinearProgress />
            ) : (
                packageResponse && (
                    <BundleTable
                        packages={packageResponse.data}
                        pageNumber={packageResponse.pageNumber}
                        totalCount={packageResponse.totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        isFetching={isFetching}
                        setPage={setPage}
                        setRowsPerPage={setRowsPerPage}
                        onDelete={handleDelete}
                        onEdit={handleRowUpdate}
                    />
                )
            )}

            <BundleDialog
                editPackage={currentRowData}
                coursePriceId={coursePriceId}
                open={openBundleDialog}
                handleClose={() => setOpenBundleDialog(false)}
            />
        </Box>
    )
}

export default BundleTab
